module.exports = __webpack_public_path__ + "img/Group_27923.117a45a2.svg";